import { Component } from "react";
import Table from 'react-bootstrap/Table';


class FunctionalOutcomeTable extends Component {
    static Title = "References to functional outcomes"
    render() {
        return (
            <Table className='border'>
                <thead className='smoke30-bg'>
                  <tr>
                    <th>Functional outcome</th>
                    <th>Ref.</th>              
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Hear alerts and warning sounds</td>
                    <td>
                      <ol>
                        <li>[15]</li>
                        <li>[18]</li>
                      </ol>
                    </td>
                  </tr>                                
                  <tr>
                    <td>Watch television and listen to music</td>
                    <td>
                      <ol>
                        <li>[16]</li>
                        <li>[17]</li>
                      </ol>
                    </td>
                  </tr>
                  <tr>
                    <td>Have a conversation on the phone</td>
                    <td>
                      <ol>
                        <li>[14]</li>
                        <li>[16]</li>
                        <li>[17]</li>
                      </ol>
                    </td>
                  </tr>
                  <tr>
                    <td>Have a one-on-one conversation</td>
                    <td>
                      <ol>
                        <li>[16]</li>
                        <li>[17]</li>
                        <li>[19]</li>
                      </ol>
                    </td>
                  </tr>                                                     
                </tbody>
            </Table>
            );
    }
}
export default FunctionalOutcomeTable 